import React from 'react'
import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT, SmallP, Link } from '@xfers/design-system'
import { ConfigManager, COUNTRY } from '~/managers/ConfigManager'

const Footer = () => (
  <FooterContainer>
    {ConfigManager.getCountry() === COUNTRY.SINGAPORE ? (
      <Advisory>
        Consumer advisory - XFERS PTE. LTD. is the holder of a Major Payment Institution license for
        e-money issuance under the new Payment Services Act. The electronically stored monetary
        value issued by XFERS PTE. LTD. is regarded as "e-money" under Singapore law. Consumers
        (Users) are advised to read our{' '}
        <Link
          size="small"
          href="https://www.xfers.com/sg/terms-of-service"
          rel="noopener noreferrer"
          target="_blank"
        >
          terms of service
        </Link>{' '}
        carefully.
      </Advisory>
    ) : (
      <Advisory>
        All material herein © by XFERS under its respective entities. All rights reserved.
      </Advisory>
    )}
  </FooterContainer>
)

export default Footer

const FooterContainer = styled(SmallP)`
  min-width: 100%;
  flex-grow: 1;
  color: #777777;
  background-color: white;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${DESKTOP_BREAKPOINT} {
    background-color: #f6f7f9;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
  }
`

const Advisory = styled(SmallP)`
  color: #777777;
`
